import React from 'react';
import { Helmet } from 'react-helmet';
import './pagestyles/Weekend.css';

const Weekend = () => {
  return (
    <>
      <Helmet>
        <title>Weekend - Long Reads & In-Depth Analysis | Redbox Global</title>
        <meta name="description" content="Explore Redbox Global Weekend edition with long-form journalism, in-depth features, cultural insights, and thought-provoking analysis. Perfect for weekend reading." />
        <meta name="keywords" content="weekend news, long reads, in-depth analysis, weekend edition, feature stories, cultural insights, weekend journalism, business features" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://redboxglobal.com/weekend" />
        <meta property="og:title" content="Weekend - Long Reads & In-Depth Analysis | Redbox Global" />
        <meta property="og:description" content="Long-form journalism, in-depth features, and thought-provoking analysis for your weekend reading." />
        <meta property="og:image" content="https://images.unsplash.com/photo-1506784983877-45594efa4cbe?w=1200&h=630&fit=crop" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://redboxglobal.com/weekend" />
        <meta name="twitter:title" content="Weekend - Long Reads & In-Depth Analysis | Redbox Global" />
        <meta name="twitter:description" content="Long-form journalism, in-depth features, and thought-provoking analysis for your weekend reading." />
        <meta name="twitter:image" content="https://images.unsplash.com/photo-1506784983877-45594efa4cbe?w=1200&h=630&fit=crop" />
        
        {/* Additional SEO */}
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Redbox Global" />
        <link rel="canonical" href="https://redboxglobal.com/weekend" />
      </Helmet>
      
      <div className="page-container">
        <div className="page-header">
          <h1>Weekend</h1>
          <p className="page-subtitle">Long reads, cultural insights, and in-depth storytelling for your leisure time</p>
        </div>
        
        <div className="page-content">
          <a href="/article/silicon-valley-crisis" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <div className="featured-article">
              <div className="featured-image">
                <img src="https://images.unsplash.com/photo-1506784983877-45594efa4cbe?w=1200&h=600&fit=crop" alt="Weekend feature" />
              </div>
              <div className="featured-content">
               
                <h2>The Silicon Valley Identity Crisis</h2>
                <p>After decades of unbridled optimism and disruption, tech's elite are questioning everything. An intimate look at the existential reckoning transforming the industry's culture, values, and future. From San Francisco lofts to Palo Alto boardrooms, we explore how the next generation of founders are redefining success.</p>
                <span className="article-meta">15 min read • By Sarah Mitchell</span>
              </div>
            </div>
          </a>

          <div className="content-grid">
            <a href="/article/art-of-dealmaking" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <article className="article-card">
                <div className="article-image">
                  <img src="https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=600&h=400&fit=crop" alt="Dealmaking" />
                </div>
                <div className="article-content">
                  
                  <h2>The Art of the $10 Billion Deal</h2>
                  <p>Inside the high-stakes world of mega-mergers with the dealmakers who orchestrate them.</p>
                  <span className="article-meta">12 min read</span>
                </div>
              </article>
            </a>

            <a href="/article/future-of-luxury" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <article className="article-card">
                <div className="article-image">
                  <img src="https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=600&h=400&fit=crop" alt="Luxury retail" />
                </div>
                <div className="article-content">
                  
                  <h2>Redefining Luxury in the Digital Age</h2>
                  <p>How Gen Z is transforming the $300 billion luxury market with new values and expectations.</p>
                  <span className="article-meta">10 min read</span>
                </div>
              </article>
            </a>

            <a href="/article/climate-entrepreneurs" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <article className="article-card">
                <div className="article-image">
                  <img src="https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?w=600&h=400&fit=crop" alt="Climate innovation" />
                </div>
                <div className="article-content">
                  
                  <h2>The Climate Entrepreneurs Racing Against Time</h2>
                  <p>Meet the innovators betting their careers on solving the world's most urgent crisis.</p>
                  <span className="article-meta">14 min read</span>
                </div>
              </article>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Weekend;
